import { COMPONENT_STATES, COMPONENT_TYPE, CONTENT_ALIGN_Y, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const card = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.CARD> =>
	createModel({
		type: COMPONENT_TYPE.CARD,
		editorProps: {
			draggable: false,
		},
		componentProps: {
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.contentLayout.contentAlignY]: CONTENT_ALIGN_Y.top,
						[OTHER_PROPS.card.muted]: true,
					},
				},
			},
			styles: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.CARD>;
